var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.477 19.47a7.455 7.455 0 1 1-3-2.333",
    stroke: "#35404A",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.323 28.359a4.126 4.126 0 0 1-1.44-.241 2.394 2.394 0 0 1-.8-.488c-.207-.189-.171-.51.038-.695.244-.216.623-.158.884.038.096.072.2.137.314.195.321.157.654.242.997.256l-.022-3.044a5.69 5.69 0 0 1-.902-.305 3.403 3.403 0 0 1-.77-.486 2.173 2.173 0 0 1-.52-.68 2.201 2.201 0 0 1-.2-.945 2.193 2.193 0 0 1 .696-1.647 2.57 2.57 0 0 1 .763-.497 2.71 2.71 0 0 1 .897-.235l-.003-.503a.288.288 0 1 1 .575-.004l.004.503c.431-.003.855.074 1.272.23.247.092.47.212.67.36.238.179.216.524-.003.726-.212.196-.542.16-.774-.009a1.847 1.847 0 0 0-.294-.175 1.857 1.857 0 0 0-.865-.197l.023 2.985c.32.101.632.21.937.328.304.118.573.268.806.45.241.174.43.392.568.655.146.262.22.59.223.98a2.246 2.246 0 0 1-.742 1.72c-.222.21-.485.375-.787.498a3.242 3.242 0 0 1-.97.223l.005.563a.288.288 0 1 1-.575.004l-.005-.563zm-.058-7.839c-.39.075-.705.241-.943.499-.23.25-.343.566-.34.95 0 .207.034.383.1.526.072.143.165.266.277.37.121.102.258.193.41.272.16.07.333.141.517.212l-.02-2.829zm.627 6.9c.407-.051.745-.21 1.015-.475.277-.266.415-.59.412-.974a1.246 1.246 0 0 0-.124-.563 1.24 1.24 0 0 0-.327-.405 1.801 1.801 0 0 0-.469-.272 3.793 3.793 0 0 0-.529-.2l.021 2.889z",
    fill: "#31B59F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.876 18.628a11.094 11.094 0 0 1 9.629-5.574 11.09 11.09 0 0 1 9.423 5.233l-1.016-.292a.5.5 0 0 0-.276.96l2.28.657a.5.5 0 0 0 .633-.412l.329-2.35a.5.5 0 1 0-.99-.138l-.14 1a12.09 12.09 0 0 0-10.243-5.658c-4.49 0-8.408 2.446-10.495 6.076a.5.5 0 0 0 .866.498zM34.123 29.372a11.094 11.094 0 0 1-9.628 5.575 11.09 11.09 0 0 1-9.423-5.234l1.016.293a.5.5 0 1 0 .276-.962l-2.28-.655a.5.5 0 0 0-.633.41l-.329 2.35a.5.5 0 1 0 .99.14l.14-1a12.09 12.09 0 0 0 10.243 5.658c4.49 0 8.408-2.447 10.495-6.077a.5.5 0 0 0-.867-.498z",
    fill: "#35404A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.4ea517a7439b98f17c427e77d5310bbf.svg";
export { ForwardRef as ReactComponent };